import { gql } from '@apollo/client';

export const ATTRUBUTE_BASIC_FRAGMENT = gql`
  fragment AttributeBasic on Attribute {
    id
    name
    type
    unit
    withChoices
    inputType
    isMain
    category {
      id
      name
      description
    }
  }
`;

export const ATTRUBUTE_VALUE_BASIC_FRAGMENT = gql`
  fragment AttributeValueBasic on AttributeValue {
    id
    name
    slug
    value
    inputType
    file {
      url
      contentType
    }
    boolean
    plainText
    richText
    date
    dateTime
  }
`;

export const ATTRUBUTE_BASIC_TRANSLATION_FRAGMENT = gql`
  fragment AttributeBasicTranslation on Attribute {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
    type
    unit
    withChoices
    inputType
    isMain
    category {
      id
      name
      description
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
`;

export const ATTRUBUTE_VALUE_BASIC_TRANSLATION_FRAGMENT = gql`
  fragment AttributeValueBasicTranslation on AttributeValue {
    id
    name
    translation(languageCode: $languageCode) {
      name
    }
    slug
    value
    inputType
    file {
      url
      contentType
    }
    boolean
    plainText
    richText
    date
    dateTime
  }
`;
